import { Box, Tabs, Tab, Typography } from "@mui/material";
import React, { useState } from "react";
import { IFPFileDeleteRequest, IFoundationProgramFileRequest, IFoundationProgramProps, TabPanelProps } from "./foundationProgramModels";
import { FoundationProgramSubjects } from "./foundationProgramSubjects";
import { FoundationProgramFiles } from "./foundationProgramFiles";
import { IFoundationProgramFile, IProgramClass, IProgramWorkSheet } from "../../common/models/foundationProgram";
import { useProgramDetailsContext, useProgramFilesContext } from "./foundationProgramContext";
import { useFoundationProgramUIContext } from "./foundationProgramUIContext";
import FoundationProgramService from "./foundationProgramService";
import { toast } from "react-toastify";



function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0, pt: 3, px: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export const FoundationProgramContent = () => {
    const programDetailsContext = useProgramDetailsContext();
    const programFilesContext = useProgramFilesContext();
    const { classDetails, programDetails } = programDetailsContext;
    const { activeWorkSheetId, setActiveWorkSheetId } = useFoundationProgramUIContext();
    const [fileUploadIsInProgress, setFileUploadIsInProgress] = useState<boolean>(false);

    const handleWorkSheetTabChange = (event: React.SyntheticEvent, newValue: number) => {
        const workSheet = classDetails?.workSheets[newValue];
        if (workSheet) setActiveWorkSheetId(workSheet.workSheetId);
    };

    // Find the index of the active worksheet for Tabs
    const activeTabIndex = classDetails?.workSheets.findIndex(ws => ws.workSheetId === activeWorkSheetId) ?? 0;

    // On initial mount, set the first worksheet as active if not set
    React.useEffect(() => {
        if (classDetails?.workSheets.length && activeWorkSheetId == null) {
            setActiveWorkSheetId(classDetails.workSheets[0].workSheetId);
        }
    }, [classDetails, activeWorkSheetId, setActiveWorkSheetId]);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, workSheetDetails: IProgramWorkSheet) => {
        const uploadedFiles = Array.from(e.target.files || []);
        setFileUploadIsInProgress(true);
        FoundationProgramService.fileUpload(uploadedFiles, { classId: programDetailsContext.classId, programId: programDetailsContext.programId, workSheetId: workSheetDetails.workSheetId } as IFoundationProgramFileRequest)
            .then((response) => {
                if (response.data.errors !== undefined && response.data.errors !== null && response.data.errors.length > 0) {
                    toast.error("error in uploading the files");
                }
                else {
                    programFilesContext.updateFiles([...programFilesContext.programFiles, ...response.data.list]);
                }
            }).finally(() => {
                setFileUploadIsInProgress(false);
                //foundationProgram.reloadFiles();
            });
    }

    const handleFileDelete = (fileDetails: IFoundationProgramFile) => {
        const programFiles = programFilesContext.programFiles;
        const fileIndex = programFiles.findIndex(i => i.fileId === fileDetails.fileId);
        programFiles[fileIndex] = { ...fileDetails, isDeleteInProgress: true };
        programFilesContext.updateFiles(programFiles);

        FoundationProgramService.deleteFile({ fileId: fileDetails.fileId } as IFPFileDeleteRequest)
            .then((response) => {
                if (response.data.errors !== undefined && response.data.errors !== null && response.data.errors.length > 0) {
                    toast.error("error in deleting the files");
                }
                else {
                    const programFilesData = programFilesContext.programFiles.filter(i => i.fileId !== fileDetails.fileId);
                    programFilesContext.updateFiles([...programFilesData]);
                    toast.success("file deleted successfully");
                }
            }).finally(() => {


            });
    }

    const getFilteredFiles = (workSheet: IProgramWorkSheet): IFoundationProgramFile[] => {
        return programFilesContext.programFiles.filter(i => i.workSheetId === workSheet.workSheetId);
    }
    const WorkSheetContent = (wprkSheetContentprops: { workSheet: IProgramWorkSheet }) => {
        const { workSheet } = wprkSheetContentprops;
        if ((workSheet.subjects != undefined && workSheet.subjects.length > 0)) {
            return <FoundationProgramSubjects workSheetDetials={workSheet} ></FoundationProgramSubjects>
        }
        else {
            return <FoundationProgramFiles
                handleFileChange={(e) => handleFileChange(e, workSheet)}
                programFiles={getFilteredFiles(workSheet)}
                fileUploadIsInProgress={fileUploadIsInProgress}
                handleDelete={handleFileDelete}
            />

        }
        return <></>;
    }
    return (
        <>
            <Box className="program-files" sx={{ flexGrow: 1, bgcolor: 'background.paper', height: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'grey.50', px: 3 }}>
                    <Tabs
                        value={activeTabIndex}
                        onChange={handleWorkSheetTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{ minHeight: 44, '& .MuiTab-root': { minHeight: 44, fontWeight: 600, fontSize: '0.82rem', textTransform: 'none' } }}
                    >
                        {
                            classDetails?.workSheets.map((workSheet, index) => (
                                <Tab
                                    key={workSheet.workSheetId ?? index}
                                    label={workSheet.workSheetName}
                                    {...a11yProps(index)}
                                    wrapped={true}
                                />
                            ))
                        }
                    </Tabs>
                </Box>
                {
                    classDetails?.workSheets.map((workSheet, index) => (
                        <CustomTabPanel
                            key={workSheet.workSheetId ?? index}
                            value={activeTabIndex}
                            index={index}
                        >
                            <WorkSheetContent workSheet={workSheet} />
                        </CustomTabPanel>
                    ))
                }
            </Box>
        </>
    );
}